import { AxiosInstance } from "axios";
import { useAxiosInterceptors } from "@/config/axios";


export class LoginApi {
  axiosInstance: AxiosInstance | undefined;

  constructor() {
    this.axiosInstance = useAxiosInterceptors();
  }
  
  async login(username: string, password: string) {
    const response = await this.axiosInstance!.post('/auth/login', { username, password });
    if (response.status === 201) {
      return response.data;
    }

  };

};
